<template>
  <div v-if="show" class="alert animated fadeIn" :class="`alert-${variant}`" role="alert">
    <i class="fa animated pulse" :class="icon"></i> {{message}}
  </div>
</template>

<script>
import alertMixin from './alert-mixin'

export default {
  mixins: [alertMixin]
}
</script>



// WEBPACK FOOTER //
// Alert.vue?d1b8e916